export enum TranslationNamespaceEnum {
  Common = "common",
  DashboardPage = "dashboardPage",
  NotFoundPage = "notFoundPage",
  LoginPage = "loginPage",
  DataGridComponent = "dataGridComponent",
  RecommendationPanel = "recommendationPanel",
  DateRangePicker = "dateRangePicker",
  SelectComponent = "selectComponent",
  AutocompleteComponent = "autocompleteComponent",

  ProTabsComponent = "proTabsComponent",
  CopyButtonComponent = "copyButtonComponent",
  PaginationComponent = "paginationComponent",
  CkeditorComponent = "ckeditorComponent",
  TextAreaComponent = "textAreaComponent",
  ErrorBoundaryComponent = "errorBoundaryComponent",
  FileInputComponent = "fileInputComponent",
  InputPlaceholdersComponent = "inputPlaceholdersComponent",
  DropZoneInputComponent = "dropZoneInputComponent",
  DropZoneInputComponentV2 = "dropZoneInputComponentV2",
  TransferListComponent = "transferListComponent",
  CommentsFormPanel = "commentsFormPanel",
  BillBalance = "billBalance",
  MarketplaceField = "marketplaceField",
  InternalServerError = "internalServerError",
  Bill = "bill",
  FormComponent = "formComponent",
  TransferPanel = "transferPanel",
  PricePanel = "pricePanel",
  Administration = "administration",
  ExonnEpost = "exonnEpost",
  ExonnInstallations = "exonnInstallations",
  EpostLetters = "epostLetters",

  AdminLayout = "AdminLayout",
  ProcessesPanel = "processesPanel",

  ManageAttributeValues = "manageAttributeValues",
  AssignAttributesToVariant = "assignAttributesToVariant",

  DateRangeStatusCell = "dateRangeStatusCell",

  SelectProductTypeModal = "selectProductTypeModal",
  SelectPriceListsModal = "selectPriceListsModal",
  AssignComponentsToSetModal = "assignComponentsToSetModal",
  DeleteRecordConfirmationModal = "deleteRecordConfirmationModal",

  EditAttributeValueModal = "editAttributeValueModal",
  CreateAttributeValueModal = "createAttributeValueModal",
  DeleteAttributeValueModal = "deleteAttributeValueModal",
  FormContactsPanel = "formContactsPanel",

  SetComponentList = "setComponentList",

  ProductsImport = "productsImport",
  AccountingExport = "accountingExport",

  EditWarehousePlacesTab = "EditWarehousePlacesTab",

  UnexpectedError = "unexpectedError",
  UpdateRequiredModal = "updateRequiredModal",

  BalanceList = "balanceList",
  Picking = "picking",
  ScaninfoComponent = "scaninfoComponent",
}

export type NamespaceTester = (ns: string, lang: string) => string | undefined;
